module.exports = __webpack_public_path__ + "static/media/鼎宏集团最新宣传片.7aa527ec.mp4";